export { useMenuDivider_unstable as useMenuDivider } from '@fluentui/react-menu';
